import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import TabHeader from "@/components/admin/TabHeader";
import ImageListEditor from "@/components/admin/ImageListEditor";

const LABELS = {
  kingsley_signature: "Kingsley — signature looks (3 photos under the logo)",
  kingsley_atelier: "Kingsley — “In the atelier” strip (3 photos)",
};

function ImageSet({ set, onSaved }) {
  const [imgs, setImgs] = useState(set.images);
  const dirty = JSON.stringify(imgs) !== JSON.stringify(set.images);
  const save = async () => {
    try { await api.put(`/admin/site-images/${set.key}`, { images: imgs }); toast.success("Imagery saved"); onSaved(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid={`admin-imageset-${set.key}`} className="bg-paper p-6">
      <div className="mb-4 flex items-center justify-between gap-4">
        <p className="font-body text-sm text-ink">{LABELS[set.key] || set.label || set.key}</p>
        <button type="button" data-testid={`imageset-save-${set.key}`} disabled={!dirty || imgs.length === 0} onClick={save} className="bg-ink px-5 py-2.5 text-paper disabled:opacity-30"><span className="overline">Save</span></button>
      </div>
      <ImageListEditor images={imgs} onChange={setImgs} max={3} testid={`imageset-${set.key}`} />
    </div>
  );
}

export default function ImageryTab() {
  const [sets, setSets] = useState([]);
  const load = () => api.get("/admin/site-images").then((r) => setSets(r.data));
  useEffect(() => { load(); }, []);
  return (
    <div data-testid="admin-imagery-tab">
      <TabHeader title="Site imagery" note="Swap the feature photos on the boutique page. Room covers are under Rooms, and piece photos under Store items." />
      <div className="space-y-4">{sets.map((s) => <ImageSet key={s.key + s.images.join()} set={s} onSaved={load} />)}</div>
    </div>
  );
}
